import { render, staticRenderFns } from "./PackingList.vue?vue&type=template&id=f56c5d4a"
import script from "./PackingList.vue?vue&type=script&lang=js"
export * from "./PackingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56c5d4a')) {
      api.createRecord('f56c5d4a', component.options)
    } else {
      api.reload('f56c5d4a', component.options)
    }
    module.hot.accept("./PackingList.vue?vue&type=template&id=f56c5d4a", function () {
      api.rerender('f56c5d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/packaging/PackingList.vue"
export default component.exports